<div class="container d-flex align-items-center justify-content-center" style="min-height: 100vh;">
  <div class="card shadow-sm w-100" style="max-width: 500px;">
    <div class="card-body p-4">
      <h2 class="text-center mb-4 font-weight-bold">Connexion</h2>

      <form (ngSubmit)="login()" [formGroup]="loginForm">
        <!-- Message d'erreur général -->
        <div *ngIf="loginError" class="alert alert-danger mb-3">
          {{ loginError }}
        </div>

        <!-- Champ Identifiant (dynamique basé sur primaryKey) -->
        <div class="form-group mb-3" *ngIf="primaryKeyField">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Identifiant ({{ primaryKeyField.label }})</mat-label>
            <input
              matInput
              formControlName="username"
              id="username"
              placeholder="Saisissez votre {{ primaryKeyField.label }}..."
              type="text"
              [attr.autocomplete]="primaryKeyField.autocomplete || 'off'">
            <mat-error *ngIf="loginForm.get('username')?.errors?.['required']">
              Le {{ primaryKeyField.label }} est requis
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Champ Mot de passe (dynamique basé sur password=true) -->
        <div class="form-group mb-3" *ngIf="passwordField">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Mot de passe ({{ passwordField.label }})</mat-label>
            <input
              matInput
              formControlName="password"
              id="password"
              [type]="showPassword ? 'text' : 'password'"
              placeholder="Saisissez votre {{ passwordField.label }}"
              [attr.autocomplete]="passwordField.autocomplete || 'off'">
            <button
              mat-icon-button
              matSuffix
              (click)="togglePasswordVisibility()"
              type="button"
              tabindex="-1">
              <mat-icon>{{ showPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
            <mat-error *ngIf="loginForm.get('password')?.errors?.['required']">
              Le {{ passwordField.label }} est requis
            </mat-error>
            <mat-error *ngIf="loginForm.get('password')?.errors?.['minlength']">
              Le {{ passwordField.label }} doit contenir au moins 5 caractères
            </mat-error>
          </mat-form-field>

          <div class="alert alert-info mt-3 mb-4">
            <div class="d-flex">
              <div>
                <p class="mb-1 font-weight-medium">Où trouver vos informations ?</p>
                <p class="mb-0">
                  Veuillez renseigner votre {{ primaryKeyField?.label }} et votre {{ passwordField.label }} exactement comme sur le courrier que vous avez reçu.
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Bouton de connexion -->
        <button
          mat-raised-button
          color="primary"
          class="w-100"
          type="submit"
          [disabled]="loginForm.invalid || isLoading">
          <span *ngIf="!isLoading">Se connecter</span>
          <span *ngIf="isLoading" class="d-flex align-items-center justify-content-center">
            <mat-spinner diameter="20" class="me-2"></mat-spinner>
            Chargement...
          </span>
        </button>
      </form>
    </div>
  </div>
</div>
